import * as PIXI from "pixi.js";
import Panel from "../../../entities/Panel/Panel";
import { eventBus, EnumEventBus } from "../../EventBus";
import ButtonFactory from "./PractiseButtonFactory";
import SwitcherButton from "../../../../../../../src/entities/UI/SwitcherButton/SwitcherButton";
import SelectBox from "../../../../../../../src/entities/UI/SelectBox/SelectBox";
import { DrawToolsSlctBxItemList, DrawToolsSelectBoxCnfg, SheetSelectBoxCnfg, SheetSelectBoxItemList } from "../../../types/Config";
import { QuestionType } from "../../../types/Enum";
import Checkbox from "../../../../../../../src/entities/UI/Checkbox/Checkbox";


export default class ButtonManager extends PIXI.Container {
  private Panel = Panel.getInstance();
  private AnimateButton!: SwitcherButton;
  private SelectBox!: SelectBox;
  private SheetSelectBox!: SelectBox;
  private qTCheckboxArr: Checkbox[] = []
  private qCboxesStatus = {
    [`${QuestionType.TYPE1}`]: true,
    [`${QuestionType.TYPE2}`]: true,
  }
  constructor() {
    super();
    this.addCheckBoxes();
    this.addButtons();
    this.addToLayer();

    eventBus.on(EnumEventBus.setTracingMode, (v: boolean) => this.AnimateButton.visible = v);
  }

  private addToLayer = () => this.Panel.addChild(this);
  private addButtons() {
    this.addChild(
      ButtonFactory.genGoToTestModeButton(),
      ButtonFactory.genGenRandomlyQuestionButton(),
      ButtonFactory.genShowSolutionButton(),
      ButtonFactory.genTracingPaperButton(),
      ButtonFactory.genHintButton()
    );

    this.AnimateButton = this.addChild(ButtonFactory.genAnimateButton());
    this.SheetSelectBox = this.addChild(new SelectBox(SheetSelectBoxItemList, 0, SheetSelectBoxCnfg));
    this.SelectBox = this.addChild(new SelectBox(DrawToolsSlctBxItemList, 3, DrawToolsSelectBoxCnfg));
  }
  addCheckBoxes() {
    const handleFunc = (type: QuestionType, v: boolean) => {
      this.qCboxesStatus[`${type}`] = v;
      if (!this.qCboxesStatus.TYPE1 && !this.qCboxesStatus.TYPE2) {
        const is1 = type == QuestionType.TYPE1;
        this.qCboxesStatus[`${is1 ? QuestionType.TYPE2 : QuestionType.TYPE1}`] = true;
        this.qTCheckboxArr[is1 ? "1" : "0"].setChecked(true);
      }
      eventBus.emit(EnumEventBus.setActiveQuestionType, this.qCboxesStatus)
    }

    this.qTCheckboxArr = [QuestionType.TYPE1, QuestionType.TYPE2].map(t => ButtonFactory.genTypeCheckbox(t, (v) => handleFunc(t, v)))
    this.qTCheckboxArr.forEach(c => c.addToCon(this));
  }
}